<template>
    <div>
      <!-- <div class="card-header card-header-flex">
          <div class="d-flex flex-column justify-content-center mr-auto">
            <b-dropdown variant="Clear" text="Export ข้อมูล" class="mb-3 mr-2">
              <b-dropdown-item type="button" v-clipboard:copy="JSON.stringify(this.selectedRowKeys)"
                v-clipboard:success="onCopy" v-clipboard:error="onError"><i class="fa fa-copy mr-1" />Copy!
              </b-dropdown-item>
              <b-dropdown-item @click="checkDataExcel(json_data)">
                <download-excel :data="json_data" :fields="json_fields" :name="fileName">
                  <i class="fa fa-file-excel-o mr-1" />Export Excel Select
                </download-excel>
              </b-dropdown-item>
              <b-dropdown-item>
                <download-excel :data="dataExport" :fields="json_fields" :name="fileName">
                  <i class="fa fa-file-excel-o mr-1" />Export Excel All
                </download-excel>
              </b-dropdown-item>
            </b-dropdown>
          </div>
          <div class="d-flex flex-column justify-content-center">
            <a-checkbox @change="getAutoRefresh(refresh)">
                รีเฟรชอัตโนมัติ {{(this.refresh) ? myVal : ''}}
            </a-checkbox>
          </div>
          <div class="d-flex flex-column justify-content-center">
              <a class="btn btn-primary" href="javascript: void(0);" @click="getDataDeposiit()"><i class="fe fe-rotate-cw mr-1" /> รีเฟรช</a>
          </div>
      </div> -->
      <tableProvider v-bind="sentData" @getData-table="getDataDeposiit()" @clear-reload="clearReload"></tableProvider>
      <!-- <a-table :columns="columns" :dataSource="dataTable" :loading="isLoading" :row-selection="rowSelection" rowKey='num_row' :pagination="{defaultPageSize: 10, pageSizeOptions: ['10', '20', '30', '40', '50', '100'], showSizeChanger : true }">
        <div
          slot="filterDropdown"
          slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
          class="custom-filter-dropdown"
        >
          <a-input
            v-ant-ref="c => searchInput = c"
            :placeholder="`Search ${column.dataIndex}`"
            :value="selectedKeys[0]"
            @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
            @pressEnter="() => handleSearch(selectedKeys, confirm)"
            style="width: 188px; margin-bottom: 8px; display: block;"
          />
          <a-button
            type="primary"
            @click="() => handleSearch(selectedKeys, confirm)"
            size="small"
            style="width: 90px; margin-right: 8px"
          >
            Search
          </a-button>
          <a-button
            @click="() => handleReset(clearFilters)"
            size="small"
            style="width: 90px"
          >
            Reset
          </a-button>
        </div>
        <a-icon
          slot="filterIcon"
          slot-scope="filtered"
          type="search"
          :style="{ color: filtered ? '#108ee9' : undefined }"
        />
      </a-table> -->
    </div>
  </template>

<script>

import { mapGetters } from 'vuex'
import apiClient from '@/services/api'
import tableProvider from './tableProvider'
// import moment from 'moment'
import Swal from 'sweetalert2'
// // import axios from 'axios'
// const Toast = Swal.mixin({
//   toast: true,
//   position: 'top-end',
//   showConfirmButton: false,
//   timer: 3000,
//   timerProgressBar: true,
//   didOpen: (toast) => {
//     toast.addEventListener('mouseenter', Swal.stopTimer)
//     toast.addEventListener('mouseleave', Swal.resumeTimer)
//   },
// })
export default {
  components: {
    tableProvider,
  },
  computed: {
    ...mapGetters({
      getStartDate: 'getStartDate',
      getEndDate: 'getEndDate',
      getProviderId: 'getProviderId',
    }),
    sentData: function() {
      return {
        dataPeer2Pay: this.dataPeer2Pay,
        dataHengPay: this.dataHengPay,
        dataThaiking: this.dataThaiking,
        dataCapitalPay: this.dataCapitalPay,
        dataFirst2Pay: this.dataFirst2Pay,
        columns: this.columns,
        isLoading: this.isLoading,
      }
    },
  },
  watch: {
    getStartDate: function(val) {
      if (val) this.getDataDeposiit()
    },
    getEndDate: function(val) {
      if (val && !this.checkFistPage) {
        this.getDataDeposiit()
      }

      if (this.checkFistPage) this.checkFistPage = false
    },
    getProviderId: function(val) {
      if (val) this.getDataDeposiit()
    },
    selectedRowKeys: function(val) {
      if (val) {
        this.dataToExcel(val)
      }
    },
  },

  data() {
    return {
      isLoading: false,
      checkFistPage: true,
      dataPeer2Pay: [],
      dataHengPay: [],
      dataThaiking: [],
      dataCapitalPay: [],
      dataFirst2Pay: [],
      columns: [
        {
          title: 'ยูสเซอเนม',
          key: 'username',
          dataIndex: 'username',
          //   width: 200,
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'username',
          },
          onFilter: (value, record) => record.username.toLowerCase().includes(value.toLowerCase()),
        },
        {
          title: 'เติมเงิน/บาท',
          key: 'amountDeposit',
          //   width: 150,
          dataIndex: 'amountDeposit',
          customRender: (text, row, index) => {
            return typeof text !== 'undefined' ? text.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,') : '0.00'
          },
        },
        {
          title: 'เติมเงิน/ครั้ง',
          key: 'CountDeposit',
          //   width: 150,
          dataIndex: 'CountDeposit',
          customRender: (text, row, index) => {
            return typeof text !== 'undefined' ? text.toFixed().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,') : 0
          },
        },
        {
          title: 'ถอนเงิน/บาท',
          key: 'amountWithdraw',
          //   width: 150,
          dataIndex: 'amountWithdraw',
          customRender: (text, row, index) => {
            return typeof text !== 'undefined' ? text.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,') : '0.00'
          },
        },
        {
          title: 'ถอนเงิน/ครั้ง',
          key: 'CountWithdraw',
          //   width: 150,
          dataIndex: 'CountWithdraw',
          customRender: (text, row, index) => {
            return typeof text !== 'undefined' ? text.toFixed().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,') : 0
          },
        },
      ],
    }
  },
  methods: {
    clearReload() {
      this.isLoading = !this.isLoading
    },
    async getDataDeposiit() {
      const dataDeposit = await {
        startDate: this.getStartDate,
        endDate: this.getEndDate,
        providerId: this.getProviderId,
      }
      this.isLoading = !this.isLoading
      await apiClient.post('/depositUserSBO/getDataMember', dataDeposit).then(response => {
        this.isLoading = !this.isLoading

        const res = response.data

        this.dataPeer2Pay = res.responseData.data[0]
        this.dataHengPay = res.responseData.data[1]
        this.dataThaiking = res.responseData.data[2]
        this.dataCapitalPay = res.responseData.data[3]
        this.dataFirst2Pay = res.responseData.data[4]
      }).catch(error => {
        Swal.showValidationMessage(
            `เกิดข้อผิดพลาด: ${error.message}`,
        )
      })
    },
  },
  async created() {
    // await this.getDataWithdraw()
  },
}
</script>
